import { render, staticRenderFns } from "./ProfileBanner.vue?vue&type=template&id=bc0a36d8&scoped=true&"
import script from "./ProfileBanner.vue?vue&type=script&lang=js&"
export * from "./ProfileBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBanner.vue?vue&type=style&index=0&id=bc0a36d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0a36d8",
  null
  
)

export default component.exports